import { API } from 'utils';
import { parse } from 'date-fns';

import {
  NotificationDTO,
  Notification,
  SEVERITY_TO_VARIANT_CONFIG
} from './notifications.model';
import { RootDispatch } from '../store';
import { ResponseData } from '../../utils/Api/Api.model';

export const mapNotificationDTOToNotification = (
  dto: NotificationDTO
): Notification => {
  const base = {
    createdAt: parse(dto.createdAt, 'dd.MM.yyyy HH:mm:ss', new Date()),
    variant: SEVERITY_TO_VARIANT_CONFIG[dto.severity]
  };

  if (dto.type === 'DEFAULT') {
    return { ...dto, ...base, context: dto.context ?? {} };
  }
  return { ...dto, ...base };
};

const endpoint = '/notifications';
const effects = (dispatch: RootDispatch) => ({
  async getNotifications(): Promise<Notification[] | undefined> {
    return API.get<undefined, ResponseData<NotificationDTO[]>>(endpoint)
      .then((response) => {
        const mapped = response.data
          .map((dto) => mapNotificationDTOToNotification(dto))
          .sort((a, b) => b.createdAt.getTime() - a.createdAt.getTime());
        dispatch.notifications.setNotifications(mapped);
        return mapped;
      })
      .catch((error) => {
        console.error('getNotifications error:', error);
        return error;
      });
  }
});

export default effects;
